<script>
import Spinner from 'shared/components/Spinner.vue';
import EmojiOrIcon from 'shared/components/EmojiOrIcon.vue';

export default {
  name: 'WootButton',
  components: { EmojiOrIcon, Spinner },
  props: {
    type: {
      type: String,
      default: 'submit',
    },
    variant: {
      type: String,
      default: '',
    },
    size: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    emoji: {
      type: String,
      default: '',
    },
    colorScheme: {
      type: String,
      default: 'primary',
    },
    classNames: {
      type: [String, Object],
      default: '',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    isCentered: {
      type: Boolean,
      default: false,
    },
    viewBox: {
      type: String,
      default: '0 0 24 24',
    },
  },
  computed: {
    variantClasses() {
      if (this.variant.includes('link')) {
        return `clear ${this.variant}`;
      }
      return this.variant;
    },
    hasOnlyIcon() {
      const hasEmojiOrIcon = this.emoji || this.icon;
      return !this.$slots.default && hasEmojiOrIcon;
    },
    hasOnlyIconClasses() {
      return this.hasOnlyIcon ? 'button--only-icon' : '';
    },
    buttonClasses() {
      return [
        this.variantClasses,
        this.hasOnlyIconClasses,
        this.size,
        this.colorScheme,
        this.classNames,
        this.isDisabled ? 'disabled' : '',
        this.isExpanded ? 'expanded' : '',
        this.isCentered ? 'expanded' : '',
      ];
    },
    iconSize() {
      switch (this.size) {
        case 'tiny':
          return 12;
        case 'small':
          return 14;
        case 'medium':
          return 16;
        case 'large':
          return 18;

        default:
          return 16;
      }
    },
    showDarkSpinner() {
      return (
        this.colorScheme === 'secondary' ||
        this.variant === 'clear' ||
        this.variant === 'link' ||
        this.variant === 'hollow'
      );
    },
  },
};
</script>

<template>
  <button
    class="button"
    :type="type"
    :class="buttonClasses"
    :disabled="isDisabled || isLoading"
  >
    <template v-if="isLoading && isCentered">
      <span class="button__content flex items-center justify-center gap-2">
        <Spinner size="small" :color-scheme="showDarkSpinner ? 'dark' : ''" />
        <span v-if="$slots.default"><slot /></span>
      </span>
    </template>
    <template v-else>
      <Spinner
        v-if="isLoading"
        size="small"
        :color-scheme="showDarkSpinner ? 'dark' : ''"
      />
      <EmojiOrIcon
        v-else-if="icon || emoji"
        class="icon"
        :emoji="emoji"
        :icon="icon"
        :icon-size="iconSize"
        :viewBox="viewBox"
      />
      <span
        v-if="$slots.default"
        class="button__content"
        :class="{
          'text-left rtl:text-right': size !== 'expanded' && !isCentered,
        }"
      >
        <slot />
      </span>
    </template>
  </button>
</template>
